import { useHistory, useParams } from "react-router-dom";
import STBoardDetail from "../../../assets/styles/organisms/boardDetail.module.scss";

const EmptyComponent = () => {
  const history = useHistory();
  const { category_id } = useParams<{ category_id: string }>();
  const handleBackToListBoard = () => {
    history.push(`/message-board/categories/${category_id}`);
  };
  return (
    <div className={`${STBoardDetail.container} ${STBoardDetail.wrapper}`}>
      <div className={STBoardDetail.board}>
        <div
          className={`${STBoardDetail.emptyComponent} ${STBoardDetail.wrapper}`}
        >
          <div className={STBoardDetail.title}>
            こちらの投稿は現在公開されておりません。
          </div>
          <button
            onClick={handleBackToListBoard}
            className={STBoardDetail.navigateButton}
          >
            掲示板一覧ページへ戻る＞
          </button>
        </div>
      </div>
    </div>
  );
};

export default EmptyComponent;
